import React, { useState, useEffect } from 'react';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import { Done } from '@material-ui/icons';
import Checkbox from '@material-ui/core/Checkbox';

import { wsFindBy } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import FilterArticle from 'hooks/FilterArticle';
import ButtonDelete from 'hooks/ButtonDelete';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { wsRemove } from 'services/WService';
import { FormControlLabel } from '@mui/material';


const columns = [
  { Header: '#', accessor: 'id', width: 80 },
  { Header: 'Código', accessor: 'ItemCode', width: 120 },
  { Header: 'Nombre producto', accessor: 'ItemName' },
  { Header: 'Cód. proveedor', accessor: 'CardCode', width: 140 },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Nombre categoría', accessor: 'logi_category_description' },
  { Header: 'Nombre familia', accessor: 'logi_family_description' },
  { Header: 'Línea', accessor: 'logi_line_description' },
  { Header: 'Estado', accessor: 'state', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ModalFilterProduct(props) {
  const { open, setOpen, entity, filterCustom = {}, setProductSelect, details, getTransfer, dataChanging } = props;

  const [products, setProducts] = useState([]);
  const [notify, showNotify] = useToasty();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [deselectedProducts, setDeselectedProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);

  useEffect(() => {
    if (open) {
      setProducts([]);
      setSelectedProducts([]);
      setDeselectedProducts([]);
      setProductsLoaded(false);
  
      getProducts();
    } else {
      setProducts([]);
      setSelectedProducts([]);
      setDeselectedProducts([]);
      setProductsLoaded(false);
    }
  }, [open]);

  async function getProducts() {
    let response = await wsFindBy(entity, filterCustom);
    if (response.success) {
      setProducts(response.data);
      setProductsLoaded(true);
    }
  }

  const handleSelectProduct = (productCode) => {
    if (!productCode) {
      console.warn("Intentando agregar un ItemCode inválido:", productCode);
      return;
    }
  
    setSelectedProducts((prevSelected) => {
      const isSelected = prevSelected.includes(productCode);
      const newSelected = isSelected
        ? prevSelected.filter((code) => code !== productCode)
        : [...prevSelected, productCode];

      return newSelected;
    });
  };

  useEffect(() => {
    const newDeselected = products
      .map((p) => String(p.ItemCode))
      .filter((code) => !selectedProducts.includes(code));
    
    setDeselectedProducts(newDeselected);
  }, [selectedProducts, products]);

  async function deleteProdDetails(idsToDelete) {
    if (!idsToDelete || idsToDelete.length === 0) {
      console.log("No hay productos desmarcados para eliminar.");
      return;
    }
  
    // try {
      const response = await wsRemove(`logi/inventory/${dataChanging.id}/detail/${idsToDelete}`, { ids: idsToDelete });
  
      if (response.success) {
        console.log("Productos eliminados:", idsToDelete);
        showNotify(response.message);
        setDeselectedProducts([]);
        setOpen(false);
        getTransfer(dataChanging.id);
      }else{
        showNotify(response.message, 'error');
      }
    // } catch (error) {
    //   console.error("Error al eliminar productos:", error);
    // }
  }
  

  const handleClose = () => {
    setOpen(false);
    setProductSelect(products.filter((p) => selectedProducts.includes(p.id))); 
    setProducts([]);
  };

  useEffect(() => {
    if (!open || !productsLoaded) return;
  
    if (!details || !Array.isArray(details)) {
      console.warn("details no es un array o está vacío.");
      setSelectedProducts([]);
      return;
    }
  
    const selectedFromDetails = details
      .flatMap((detail) =>
        (detail.marks || []).flatMap((mark) =>
          (mark.lines || []).flatMap((line) =>
            (line.families || []).flatMap((family) =>
              (family.details || []).map((prod) => String(prod.ItemCode))
            )
          )
        )
      );  
    setSelectedProducts(selectedFromDetails);
  }, [details, open, productsLoaded]);
  
  const lockedProducts = products
  .map((p) => String(p.ItemCode)) 
  .filter((code) => !details?.some((detail) =>
    detail.marks?.some((mark) =>
      mark.lines?.some((line) =>
        line.families?.some((family) =>
          family.details?.some((prod) => String(prod.ItemCode) === code)
        )
      )
    )
  ));

  return (
    <ModalFull title="Filtro de Productos" open={open} setOpen={handleClose}>
      <Toasty action={notify} />
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <Button
                color={props.themeContext.buttonColorDanger}
                style={{ marginTop: '15px', float: 'left' }}
                onClick={() => {
                  const idsToDelete = deselectedProducts
                    .map(itemCode => {
                      const detail = details
                        ?.flatMap(detail =>
                          (detail.marks || []).flatMap(mark =>
                            (mark.lines || []).flatMap(line =>
                              (line.families || []).flatMap(family =>
                                (family.details || []).find(prod => prod.ItemCode === itemCode)
                              )
                            )
                          )
                        )
                        .filter(Boolean);

                      return detail.length > 0 ? detail.map(d => d.id) : null;
                    })
                    .flat()
                    .filter(Boolean);

                  if (idsToDelete.length === 0){
                    showNotify('Sin productos a eliminar', 'error');
                  }
                  deleteProdDetails(idsToDelete);
                }}
                disabled={!productsLoaded}
              >
                Eliminar los registros del detalle
              </Button>
            </GridItem>
            <GridItem xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedProducts.length > 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedProducts(products.map((p) => String(p.ItemCode)));
                      } else {
                        setSelectedProducts([]);
                      }
                    }}
                  />
                }
                label="Deseleccionar todos los productos"
              />
          </GridItem>
          </GridContainer>
          <ReactTable
            defaultWidth={1100}
            exportExcel={false}
            columns={columns}
            data={products.map((product, i) => ({
              id: (
                <div className="actions-right">
                  {i + 1}
                  <Checkbox
                    checked={selectedProducts.includes(String(product.ItemCode))}
                    onChange={() => handleSelectProduct(String(product.ItemCode))}
                    disabled={lockedProducts.includes(String(product.ItemCode))}
                  />
                </div>
              ),
              ItemCode: product.ItemCode,
              ItemName: product.ItemName,
              CardCode: product.CardCode,
              CardName: product.CardName,
              logi_category_description: product.logi_category_description,
              logi_family_description: product.logi_family_description,
              logi_line_description: product.logi_line_description,
              state: product.state === "A" ? "Activo" : "Inactivo",
              actions: "",
            }))}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
